import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { QUOTA_LEVEL_TRACKING } from '../../../shared/constants/quota-level-tracking';

@Component({
  selector: 'ps-ui-quota-level-tracking-modal',
  templateUrl: './quota-level-tracking-modal.component.html',
  styleUrls: ['./quota-level-tracking-modal.component.css'],
})
export class QuotaLevelTrackingModalComponent implements OnInit {
  public data: QuotaModalData = this._modalData;
  public buyerQuotaIds?: string[] = [];
  public modalmessage: string = '';
  public modalTitle: string = '';
  constructor(
    @Inject(ModalData)
    private _modalData: QuotaModalData,
    private _modalRef: ModalRef<QuotaLevelTrackingModalComponent, string>
  ) {}

  ngOnInit(): void {
    this.modalTitle = QUOTA_LEVEL_TRACKING.MODAL_TITLE;
    this._setModalData();
  }
  private _setModalData() {
    switch (this.data.respMessage) {
      case QUOTA_LEVEL_TRACKING.CHAR_COUNT_VALIDATION_FAIL:
        this.modalmessage = QUOTA_LEVEL_TRACKING.CHAR_COUNT_VALIDATION_MESSAGE;
        this.buyerQuotaIds = this.data.charCountExceedQuotas;
        break;

      case QUOTA_LEVEL_TRACKING.UNIQUE_FAIL:
        this.modalmessage = QUOTA_LEVEL_TRACKING.UNIQUE_FAIL_MESSAGE;
        this.buyerQuotaIds = this.data.duplicatedBuyerQuotaIds;
        break;

      case QUOTA_LEVEL_TRACKING.INPUT_VALIDATION_FAIL:
        this.modalmessage = QUOTA_LEVEL_TRACKING.INPUT_VALIDATION_FAIL_MESSAGE;
        break;
    }
  }

  public close() {
    this._modalRef.close();
  }
}
interface QuotaModalData {
  surveyId: number;
  respMessage: string;
  charCountExceedQuotas?: [];
  duplicatedBuyerQuotaIds?: [];
}
